import { useEffect, useState } from "react";
import { useSnackbar } from "JS/Helpers/Snackbar";
import { messaging } from "JS/Helpers/UserMessaging";
import {
    DownloadStatus,
    checkQuotaWithSize,
} from "JS/Helpers/ContentDownloadHelper";

export const useDownloadingStatusWithSize = (sizeInBytes?: number) => {
    const [downloadStatus, setDownloadStatus] = useState<DownloadStatus>(
        DownloadStatus.BLOCK,
    );
    const { enqueueSnackbar } = useSnackbar();

    const showWarningSnackbarIfRequired = () => {
        if (downloadStatus === DownloadStatus.WARNING)
            enqueueSnackbar(messaging.storageQuota.warning, {
                variant: "warning",
            });
    };

    useEffect(() => {
        if (sizeInBytes !== undefined) {
            checkQuotaWithSize(sizeInBytes).then(setDownloadStatus);
        }
    }, [sizeInBytes]);

    return {
        downloadStatus,
        showWarningSnackbarIfRequired,
    };
};
